import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import type { Resolver } from 'react-hook-form';

const schema = z.object({
  goToTestId: z.number().optional(),
  app: z.string().min(1, 'Can\'t be empty'),
  flow_id: z.number().min(1, 'Can\'t be empty'),
  account_id: z.string().min(1, 'Can\'t be empty'),
});

export default {
  schema,
  resolver: zodResolver(schema),
} as {
  schema: typeof schema;
  resolver: Resolver<z.infer<typeof schema>>;
};
